<template>
  <div class="content">
    <p>订单审核</p>
    <div class="actions-bar">
      <el-input placeholder="userId" clearable v-model="userId">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>

      <el-select v-model="status" disabled="" placeholder="请选择审核状态">
        <el-option label="全部" value=""></el-option>
        <el-option label="已取消" value="-1"></el-option>
        <!-- <el-option label="待付款" value="1"></el-option> -->
        <el-option label="待付款" value="2"></el-option>
        <el-option label="已付款" value="3"></el-option>
        <el-option label="完成" value="4"></el-option>
        <el-option label="待审核" value="5"></el-option>
      </el-select>
      <el-button type="primary" class="searchBtn" @click="handleSearch">搜索</el-button>
      <el-button type="success" @click="freezeBtn" plain>冻结</el-button>
    </div>
    <el-table :data="frozenList" style="width: 100%">
      <el-table-column prop="id" label="id"> </el-table-column>
      <el-table-column prop="userId" label="用户id"> </el-table-column>
      <el-table-column prop="frozenDes" label="冻结描述"> </el-table-column>
      <el-table-column prop="" label="冻结时间">
        <template slot-scope="scope">
          <span>{{ scope.row.frozenTime | moment }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="" label="更新时间">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime | moment }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="" label="解冻时间">
        <template slot-scope="scope">
          <span>{{ scope.row.unfrozenTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="unfrozenDes" label="解冻描述"> </el-table-column>
      <el-table-column prop="sellerId" label="卖家ID">
        <template slot-scope="scope">
          <a class="account-link" @click="getUserDetail(scope.row.sellerId)">{{ scope.row.sellerId }}</a>
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row.id)" type="text" size="small">解冻</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      layout="prev, pager, next, total, jumper"
      @current-change="pageChange"
      @size-change="sizeChange"
      :current-page="page"
      :page-size="size"
      :total="frozenListTotal"
      prev-text="上一页"
      next-text="下一页"
    >
    </el-pagination>

    <balance :show="showBalance" @close="showBalance = false"></balance>

    <el-dialog title="请添加冻结信息" :visible.sync="freezeDialogVisible"  @close='closeFreezeDialogVisible'>
      <el-form :model="freezeForm" ref="freezeForm2">
        <el-form-item label="用户ID"  :label-width="formLabelWidth">
          <el-input v-model.trim="freezeForm.userId" placeholder="请手动输入userId" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="冻结描述信息" :label-width="formLabelWidth">
          <el-input type="textarea"   placeholder="请添加描述,描述内容不超过200字"
              maxlength="200"
              show-word-limit v-model.trim="freezeForm.frozenDes" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="预期解冻时间" :label-width="formLabelWidth">
          <el-date-picker
            v-model="freezeForm.unfrozenTime"
            type="datetime"
            :picker-options="pickerOptions0"
            :editable="false"
            value-format="timestamp"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="freezeDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="otcFrozenBtn">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="解冻" :visible.sync="jiedongVisible" @close='closejiedongVisible'>
      <el-form :model="freezeForm">
        <el-form-item label="解冻描述" :label-width="formLabelWidth">
          <el-input type="textarea" v-model.trim="jiedongData.unfrozenDes"   placeholder="请添加描述,描述内容不超过200字"
              maxlength="200"
              show-word-limit autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="jieDongBen">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import balance from "../../../balance";
import api from "../../api";
export default {
  name: "merchantRecordList",
  data() {
    return {
      pickerOptions0: {
        onPick: ({ maxDate, minDate }) => {
          this.choiceDate = minDate.getTime();
          if (maxDate) {
            this.choiceDate = "";
          }
        },
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7 + 1000 * 60;
        }
      },
      jiedongVisible: false,
      jiedongData: {
        id: "",
        unfrozenDes: ""
      },
      userId: "",
      size: 11,
      formLabelWidth: "120px",
      freezeDialogVisible: false,
      page: 1,
      status: "5",
      id: "",
      showBalance: false,
      freezeForm: {
        //冻结from
        unfrozenTime: "",
        frozenDes: "",
        userId: ""
      }
    };
  },
  computed: {
    ...mapState("otc", ["frozenListTotal", "frozenList"])
  },
  components: { balance },
  methods: {
    ...mapActions("otc", ["getotcFrozenList"]),
closejiedongVisible(){
  this.jiedongData.unfrozenDes='';
},
closeFreezeDialogVisible(){
  　this.freezeForm.unfrozenTime='';
    　this.freezeForm.frozenDes='';
      　this.freezeForm.userId='';
},
    //解冻
    handleClick(id) {
      this.jiedongData.id = id;
      this.jiedongVisible = true;
    
    },
    jieDongBen() {
        let ssData=this.jiedongData;
        let that = this;
        api.unfrozen(ssData).then(res => {
          console.log("shenghe", res);
          if (!res.code) {
            that.$message({
              message: res.msg,
              type: "success"
            });
            that.jiedongVisible = false;
            that.handleSearch();
          } else {
            that.$message({
              message: res.msg,
              type: "error"
            });
          }
        });
    },
    //冻结btn
    freezeBtn() {
      this.freezeDialogVisible = true;
    },

    getUserDetail(uid) {
      this.getUserWallet({ userId: uid });
      this.showBalance = true;
    },
    pageChange(e) {
      console.log(e);
      this.page = e;
      this.handleSearch();
    },
    sizeChange(e) {
      this.page = e;
      this.handleSearch();
    },

    //shousuo
    handleSearch() {
      let that = this;

      if (that.id || that.userId) {
        that.status = "";
      }

      this.getotcFrozenList({
        userId: that.userId,
        size: that.size,
        page: that.page
      });
    },
    //冻结事件
    otcFrozenBtn() {
      let that = this;
      let data = this.freezeForm;
      api.otcFrozen(data).then(res => {
        console.log("shenghe", res);
        if (!res.code) {
          that.$message({
            message: res.msg,
            type: "success"
          });
          that.freezeDialogVisible = false;
          that.handleSearch();
        } else {
          that.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    }
  },

  mounted() {
    this.handleSearch();
  }
};
</script>

<style lang="less" scoped>
.content {
  .fenGeXian {
    width: 98%;
    height: 1px;
    background: #eaf0f2;
    clear: both;
    overflow: hidden;
    margin: 10px auto;
  }
  .actions-bar {
    width: 80%;
    display: flex;
    margin-bottom: 30px;
    .el-input {
      width: 300px;
      margin-right: 20px;
    }
    .searchBtn {
      margin-left: 15px;
    }
  }

  .setImgBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .imgBox {
      width: 46%;
      height: auto;
      border: 1px dashed #c8cdd1;
      padding: 12px;
      overflow: hidden;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      span {
        font-size: 14px;
        font-weight: bold;
      }
      img {
        width: 80%;
        float: right;
      }
    }
  }
}
.el-message-box {
  background: red !important;
}
</style>
